import script from "./InformationDisclosure.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationDisclosure.vue?vue&type=script&lang=ts&setup=true"

import "./InformationDisclosure.vue?vue&type=style&index=0&id=4f6b5b90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6b5b90"]])

export default __exports__